import { useStore } from 'zustand';

import { useCustomisableFormDataContext } from '../customisable-form-data/CustomisableFormDataContext';
import type { FormFieldRegistryState } from './formFieldRegistryStore';

export type {
  FieldRegistration,
  FormFieldRegistryState,
  FormFieldRegistryStore,
} from './formFieldRegistryStore';
export { createFormFieldRegistryStore } from './formFieldRegistryStore';

export const useFormFieldRegistryStore = <T>(
  selector: (state: FormFieldRegistryState) => T
): T => {
  const { fieldRegistryStore } = useCustomisableFormDataContext();

  return useStore(fieldRegistryStore, selector);
};
